import React from 'react';
import styles from './styles.scss';

function ProductAttribute({
  icon,
  title,
  description
}) {
  return (
    <div className="col-sm-6 text-left pt20 pb20">
      <div className={styles.container}>
        <div className={`${styles.titleContainer} mb20`}>
          <div className={styles.imageContainer}>
            <img src={icon} alt="title" className={styles.icon} />
          </div>
          <div className={`${styles.title} bold`}>
            {title}
          </div>
        </div>
        <div className={`${styles.description} light`}>
          {description}
        </div>
      </div>
    </div>
  );
}

export default ProductAttribute;



// WEBPACK FOOTER //
// ./src/components/ProductAttribute/index.js